module.exports = __webpack_public_path__ + "static/media/W94F1000N0000.be38f616.svg";